import { useEffect, useRef } from 'react';

interface SelectAllCheckboxProps {
  /** Keys of every selectable row. */
  keys: string[];
  selected: Set<string>;
  /** Called with the wanted state: true selects all `keys`, false clears them. */
  onChange: (checked: boolean) => void;
  label: string;
  testId?: string;
}

/** Header checkbox: checked when every key is selected, indeterminate when only some are. */
export function SelectAllCheckbox({
  keys,
  selected,
  onChange,
  label,
  testId,
}: SelectAllCheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);
  const count = keys.filter((key) => selected.has(key)).length;
  const all = keys.length > 0 && count === keys.length;
  const some = count > 0 && !all;

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = some;
  }, [some]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className="size-4 rounded border-gray-300 accent-brand-500 dark:border-gray-700"
      checked={all}
      disabled={keys.length === 0}
      onChange={(event) => onChange(event.target.checked)}
      aria-label={label}
      data-testid={testId}
    />
  );
}
